import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { GDPRService } from 'src/app/core/services/rulebook';

@Component({
  selector: 'app-rule-hierarchy',
  templateUrl: './rule-hierarchy.component.html',
  styleUrls: ['./rule-hierarchy.component.scss']
})
export class RuleHierarchyComponent implements OnInit {

  isLoading = true;
  url = 'assets/d3/rule_sunburst.html?id=';
  iframeSRC: any = null;
  isChartExpanded = false;
  showChartCont = true;
  myInnerHeight: any;

  constructor(public sanitizer: DomSanitizer, public gdprService: GDPRService) { }

  ngOnInit(): void {
    this.myInnerHeight = window.innerHeight - 180;
    if (this.gdprService.ruleTree) {
      this.iframeSRC = this.sanitizer.bypassSecurityTrustResourceUrl(this.url + this.gdprService.ruleTree);
    } else {
      this.iframeSRC = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }
  }

  expandPanel(): void {
    this.showChartCont = false;
    this.isChartExpanded = !this.isChartExpanded;
    setTimeout(() => {
      this.showChartCont = true;
    }, 100);
  }
}
